<template>
    <form autocomplete="off" class="trax-form" v-on:submit.prevent="search" v-if="form">
    
        <!-- Type -->

        <trax-ui-select col="md-3"
            v-model="form.type"
            :options="type_select"
            placeholder="Type"
        ></trax-ui-select>
    
        <!-- Status -->

        <trax-ui-select col="md-3"
            v-model="form.status"
            :options="status_select"
            placeholder="Status"
            :unselected="lang.polaris.account.all_status"
        ></trax-ui-select>

        <!-- Program -->

        <trax-ui-select col="md-3"
            v-model="form.program_id"
            :options="programs_select"
            :placeholder="lang.polaris.training.program"
            unselected="All programs"
        ></trax-ui-select>

        <!-- Training center -->

        <trax-ui-select col="md-3"
            v-model="form.entity_id"
            :options="locations_select"
            :grouped="1"
            :placeholder="lang.polaris.options.training_center"
            unselected="All locations"
        ></trax-ui-select>

        <!-- Group -->

        <trax-ui-select col="md-3"
            v-model="form.cohort_id"
            :options="groups_select" 
            :placeholder="lang.polaris.account.group"
            unselected="All groups"
        ></trax-ui-select>

        <!-- User -->

        <trax-ui-search-remote-object col="md-3"
            :placeholder="lang.polaris.dashboard.learner" 
            v-model="form.learner_id"
            :endpoint="learners_endpoint"
            unselectedLabel="Search for a student"
            noOptionLabel="No user found"
            :unselect="true"
        ></trax-ui-search-remote-object>

        <!-- Submit buttons -->

        <div class="trax-form-actions text-right">
            <button type="button" class="btn btn-default btn-link" @click="reset"> {{ lang.polaris.form.reset }} </button>
            <button type="submit" class="btn btn-primary btn-round"> {{ lang.polaris.form.search }} </button>
        </div>

    </form>
</template>

<script>
    export default {
    
        props: {
            id: null,
            bus: null
        },
        
        data() {
            return {
                lang: lang,
                user: user,
                form: this.defaultForm,
                type_select: [
                    { name: 'ATP and DAF', value: 'all' },
                    { name: 'ATP only', value: 'atp' },
                    { name: 'DAF only', value: 'daf' },
                ],
                status_select: data.procedure_status_select,
                programs_select: data.programs_select,
                groups_select: data.groups_select,
                locations_select: data.locations_select,
                learners_endpoint: app_url + 'polaris/api/front/learners/select',
            }
        },
        
        created() {
            this.bus.$on(this.id+'-filter-restore', data => {
                this.form = data;
            });
        },

        computed: {

            defaultForm() {
                return {
                    type: 'all',
                    status: null,
                    program_id: null,
                    cohort_id: null,
                    training_center: null,
                    learner_id: null,
                }
            },
        },

        methods: {

            search() {
                this.bus.$emit(this.id+'-filter', this.form);
                this.bus.$emit(this.id+'-search-close');
            },

            reset() {
                this.form = {...this.defaultForm};
                this.search();
            }
        }
            
    }
</script>
